export default __webpack_public_path__ + "static/media/item-board.2af1c6e2.png";